import React, { Component } from "react";
import Select from "react-select";
import styled from "styled-components";

const TWEMOJI_SVG_URL = "https://twemoji.maxcdn.com/2/svg";
const defaultEmojiCodes = ["1f389", "1f44d", "1f38a", "1f44f", "1f4af"];

class EmojiSelect extends Component {
  state = {
    defaultEmojis: []
  };

  componentDidMount() {
    this.setState({ defaultEmojis: this.buildDefaultEmojis() });
  }

  buildDefaultEmojis = () => {
    const { defaultImage, successColor } = this.props;
    return [
      // option for no icon
      {
        label: <EmojiWrapper />,
        value: "none"
      },
      // default emoji
      {
        label: defaultImage({
          width: "28px",
          height: "28px",
          color: successColor
        }),
        value: "default"
      },
      ...defaultEmojiCodes.map(code => {
        return {
          label: <EmojiWrapper src={`${TWEMOJI_SVG_URL}/${code}.svg`} />,
          value: `${code}`
        };
      })
    ];
  };

  render() {
    const { value, onChange, onFocus, disabled } = this.props;

    return (
      <ShorterSelect
        className={`select-emoji`}
        clearable={false}
        value={value}
        options={this.state.defaultEmojis || []}
        autosize={false}
        onChange={onChange}
        onFocus={onFocus}
        placeholder="Choose an emoji..."
        disabled={disabled}
      />
    );
  }
}

export default EmojiSelect;

const EmojiWrapper = styled.img`
  height: 28px;
  width: auto;
  padding-top: 4px;
`;

const ShorterSelect = styled(Select)`
  width: 64px;
`;
